export { Dialog as FullScreenModal, type DialogProps as FullScreenModalProps } from './Dialog'
export { PrimeDialog, type PrimeDialogProps, type PrimeDialogPassThroughOptions } from './PrimeDialog/PrimeDialog'
